(() => {
  const section = document.getElementById('yvmin-cart-gifts');
  if (!section || !document.querySelector('[data-cart-page]')) return;

  const promotion = window.FokkioShopSurprise?.promotions?.find(
    item => item.name === 'A Little More Paradise' && item.status === 'active'
  );
  if (!promotion || !Array.isArray(promotion.milestones) || promotion.milestones.length !== 3) return;

  const now = Date.now();
  if (promotion.start_datetime && now < Date.parse(promotion.start_datetime)) return;
  if (promotion.finish_datetime && now >= Date.parse(promotion.finish_datetime)) return;

  const milestones = [...promotion.milestones].sort((a, b) => a.position - b.position);
  const currency = window.Shopify?.currency?.active || 'USD';
  const rate = Number(window.Shopify?.currency?.rate) || 1;
  const goals = milestones.map(item => Math.round(Number(item.threshold.amount) * rate * 100));
  if (goals.some(goal => !Number.isFinite(goal) || goal <= 0)) return;

  const money = cents => new Intl.NumberFormat(window.Shopify?.locale || 'en', {
    style: 'currency', currency, maximumFractionDigits: 0
  }).format(cents / 100);

  const giftLinks = {
    'Paradise / Origami Star Phone Charm Pendant': '/products/paradise-origami-star-phone-charm',
    'Paradise / Silicone Star Photo Frame Charm Pendant Chain': '/products/paradise-silicone-star-photo-frame-charm',
    'Paradise / Floral Cat Incense Holder': '/products/paradise-floral-cat-incense-holder'
  };

  const amount = section.querySelector('[data-yv-gift-amount]');
  const fill = section.querySelector('[data-yv-gift-fill]');
  const message = section.querySelector('[data-yv-gift-message]');
  const detail = section.querySelector('[data-yv-gift-detail]');
  const markers = [...section.querySelectorAll('[data-yv-gift-marker]')];
  const labels = [...section.querySelectorAll('[data-yv-gift-label]')];

  goals.forEach((goal, index) => {
    const position = `${(goal / goals[2]) * 100}%`;
    markers[index].style.left = position;
    markers[index].setAttribute('aria-label', `View ${money(goal)} gift`);
    labels[index].style.left = position;
    labels[index].textContent = money(goal);
  });

  let openGift = -1;
  let lastReached;
  let pending = false;
  const announced = new Set();

  function showGift(index) {
    if (openGift === index && !detail.hidden) {
      detail.hidden = true;
      openGift = -1;
      return;
    }

    const gift = milestones[index].reward?.variants?.[0];
    if (!gift) return;
    const image = document.createElement('img');
    image.src = gift.image?.originalSrc || '';
    image.alt = gift.productTitle || 'Gift';
    const copy = document.createElement('div');
    const tier = document.createElement('span');
    tier.textContent = `${money(goals[index])} GIFT`;
    const name = document.createElement('strong');
    name.textContent = gift.productTitle || 'Paradise gift';
    copy.append(tier, name);
    const url = giftLinks[gift.productTitle];
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.textContent = 'View gift details';
      copy.appendChild(link);
    }
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close gift details');
    close.addEventListener('click', () => {
      detail.hidden = true;
      openGift = -1;
    });
    detail.replaceChildren(image, copy, close);
    detail.hidden = false;
    openGift = index;
  }

  function showToast(index) {
    document.querySelector('.yvmin-cart-gifts__toast')?.remove();
    const toast = document.createElement('div');
    toast.className = 'yvmin-cart-gifts__toast';
    toast.textContent = `You've reached the ${money(goals[index])} gift tier. Check your cart for the gift.`;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 4500);
  }

  markers.forEach((marker, index) => marker.addEventListener('click', () => showGift(index)));

  async function refresh() {
    pending = false;
    let cart;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin', cache: 'no-store'
      });
      if (!response.ok) return;
      cart = await response.json();
    } catch (_) {
      return;
    }

    if (!cart.item_count) {
      section.hidden = true;
      lastReached = undefined;
      return;
    }
    section.hidden = false;
    const total = Number(cart.total_price) || 0;
    amount.textContent = `${money(total)} / ${money(goals[2])}`;
    fill.style.width = `${Math.min(100, (total / goals[2]) * 100)}%`;

    const reached = goals.filter(goal => total >= goal).length;
    markers.forEach((marker, index) => marker.classList.toggle('is-reached', index < reached));
    if (lastReached !== undefined && reached > lastReached) {
      for (let index = lastReached; index < reached; index++) {
        if (!announced.has(index)) {
          announced.add(index);
          showToast(index);
        }
      }
    }
    lastReached = reached;

    if (reached === goals.length) {
      message.textContent = 'All three gift milestones reached. Your eligible gifts are handled in the cart.';
      return;
    }

    const gap = goals[reached] - total;
    message.textContent = `You're ${money(gap)} away from your next gift.`;
  }

  function scheduleRefresh() {
    if (pending) return;
    pending = true;
    setTimeout(refresh, 250);
  }

  const cartItems = document.querySelector('[data-items-holder]');
  const cartPrice = document.querySelector('[data-cart-price-holder]');
  const observer = new MutationObserver(scheduleRefresh);
  [cartItems, cartPrice].filter(Boolean).forEach(target => observer.observe(target, {
    childList: true, characterData: true, subtree: true
  }));
  ['theme:cart:change', 'cart:change', 'cart:updated'].forEach(name =>
    document.addEventListener(name, scheduleRefresh)
  );
  refresh();
})();
